<section class="demand-request-dialog">
  <form [formGroup]="demandForm" (ngSubmit)="createDemand()">
    <header class="demand-request-dialog__header">
      <div class="demand-request-dialog__title-group">
        <span class="demand-request-dialog__eyebrow">Solicitar novo servico</span>
      </div>

      <div class="demand-request-dialog__steps" aria-label="Etapas da solicitacao">
        <span class="demand-request-dialog__step">1. Descricao</span>
        <span class="demand-request-dialog__step demand-request-dialog__step--active">
          2. Detalhes
        </span>
      </div>
    </header>

    <mat-dialog-content class="demand-request-dialog__content">
      @if (formErrorMessage) {
        <div class="demand-request-dialog__error" role="alert">
          <i-tabler name="alert-triangle" class="demand-request-dialog__error-icon"></i-tabler>
          <span>{{ formErrorMessage }}</span>
        </div>
      }

      @if (aiWarningMessage) {
        <div class="demand-request-dialog__notice" role="status">
          <i-tabler name="sparkles" class="demand-request-dialog__notice-icon"></i-tabler>
          <span>{{ aiWarningMessage }}</span>
        </div>
      }

      <div class="demand-request-dialog__layout">
        <div class="demand-request-dialog__main">
          <section class="demand-block">
            <div class="demand-block__header">
              <div>
                <h3>Dados da solicitacao</h3>
              </div>
              @if (selectedSpecialtiesCount > 0) {
                <span class="demand-block__badge">
                  {{ selectedSpecialtiesCount }}
                  {{ selectedSpecialtiesCount === 1 ? 'especialidade' : 'especialidades' }}
                </span>
              }
            </div>

            <div class="demand-form-grid demand-form-grid--two">
              <div
                class="demand-searchable-field"
                [class.demand-searchable-field--invalid]="
                  hasControlError('serviceTypeUuid', 'required')
                "
              >
                <app-searchable-single-select
                  [options]="serviceTypeOptions"
                  [selectedValue]="demandForm.get('serviceTypeUuid')?.value"
                  (selectedValueChange)="handleServiceTypeUuidChange($event)"
                  [disabled]="loadingTypes || isSubmittingRequest"
                  placeholder="{{
                    loadingTypes ? 'Carregando tipos...' : 'Selecione o tipo'
                  }}"
                  searchPlaceholder="Buscar tipo..."
                  sectionTitle="Tipos"
                  [showSectionTitle]="false"
                  [emptyMessage]="
                    typesApiState.status === 'error'
                      ? typesApiState.message
                      : 'Nenhum tipo encontrado.'
                  "
                  selectedSummaryEmpty="Nenhum tipo selecionado"
                ></app-searchable-single-select>

                @if (typesApiState.message) {
                  <span
                    class="demand-searchable-field__hint"
                    [class.demand-searchable-field__hint--error]="
                      typesApiState.status === 'error'
                    "
                    [class.demand-searchable-field__hint--warning]="
                      typesApiState.status === 'warning'
                    "
                  >
                    {{ typesApiState.message }}
                  </span>
                }

                @if (hasControlError('serviceTypeUuid', 'required')) {
                  <span class="demand-searchable-field__error">
                    Tipo e obrigatorio
                  </span>
                }
              </div>

              <div
                class="demand-searchable-field"
                [class.demand-searchable-field--invalid]="
                  hasControlError('specialtyUuids', 'required') ||
                  hasControlError('specialtyUuids', 'minlength')
                "
              >
                <app-searchable-multi-select
                  [options]="specialtyOptions"
                  [selectedValues]="selectedSpecialtyUuids"
                  (selectedValuesChange)="handleSpecialtyUuidsChange($event)"
                  [disabled]="loadingSpecialties || isSubmittingRequest"
                  placeholder="Selecione as especialidades"
                  searchPlaceholder="Buscar especialidades..."
                  sectionTitle="Especialidades"
                  [showSectionTitle]="false"
                  [emptyMessage]="
                    specialtiesApiState.status === 'error'
                      ? specialtiesApiState.message
                      : 'Nenhuma especialidade encontrada.'
                  "
                  selectedItemSingular="especialidade selecionada"
                  selectedItemPlural="especialidades selecionadas"
                  selectedSummaryEmpty="Nenhuma especialidade selecionada"
                ></app-searchable-multi-select>

                @if (specialtiesApiState.message) {
                  <span
                    class="demand-searchable-field__hint"
                    [class.demand-searchable-field__hint--error]="
                      specialtiesApiState.status === 'error'
                    "
                    [class.demand-searchable-field__hint--warning]="
                      specialtiesApiState.status === 'warning'
                    "
                  >
                    {{ specialtiesApiState.message }}
                  </span>
                }

                @if (
                  hasControlError('specialtyUuids', 'required') ||
                  hasControlError('specialtyUuids', 'minlength')
                ) {
                  <span class="demand-searchable-field__error">
                    Selecione ao menos uma especialidade
                  </span>
                }
              </div>
            </div>

            <div
              class="demand-searchable-field"
              [class.demand-searchable-field--invalid]="
                hasControlError('localDetail', 'required')
              "
            >
              <app-searchable-single-select
                [options]="companyOptions"
                [selectedValue]="demandForm.get('localDetail')?.value"
                (selectedValueChange)="handleCompanyUuidChange($event)"
                [disabled]="loadingCompanies || isSubmittingRequest"
                placeholder="{{
                  loadingCompanies ? 'Carregando unidades...' : 'Selecione a unidade'
                }}"
                searchPlaceholder="Buscar unidade..."
                sectionTitle="Matriz/Filial"
                [showSectionTitle]="false"
                [emptyMessage]="
                  companiesApiState.status === 'error'
                    ? companiesApiState.message
                    : 'Nenhuma unidade encontrada.'
                "
                selectedSummaryEmpty="Nenhuma unidade selecionada"
              ></app-searchable-single-select>

              @if (companiesApiState.message) {
                <span
                  class="demand-searchable-field__hint"
                  [class.demand-searchable-field__hint--error]="
                    companiesApiState.status === 'error'
                  "
                  [class.demand-searchable-field__hint--warning]="
                    companiesApiState.status === 'warning'
                  "
                >
                  {{ companiesApiState.message }}
                </span>
              }

              @if (hasControlError('localDetail', 'required')) {
                <span class="demand-searchable-field__error">
                  Empresa e obrigatoria
                </span>
              }
            </div>

            <div class="demand-form-grid demand-form-grid--two demand-form-grid--divided">
              <div class="demand-searchable-field">
                <app-searchable-single-select
                  [options]="environmentOptions"
                  [selectedValue]="demandForm.get('environmentUuid')?.value"
                  (selectedValueChange)="handleEnvironmentUuidChange($event)"
                  [disabled]="
                    isSubmittingRequest ||
                    loadingEnvironments ||
                    !demandForm.get('localDetail')?.value
                  "
                  placeholder="{{
                    loadingEnvironments
                      ? 'Carregando ambientes...'
                      : environmentEmptyMessage
                  }}"
                  searchPlaceholder="Buscar ambiente..."
                  sectionTitle="Ambientes"
                  [showSectionTitle]="false"
                  [emptyMessage]="environmentEmptyMessage"
                  selectedSummaryEmpty="Nenhum ambiente selecionado"
                  clearLabel="Desmarcar"
                ></app-searchable-single-select>

                @if (environmentsApiState.message) {
                  <span
                    class="demand-searchable-field__hint"
                    [class.demand-searchable-field__hint--error]="
                      environmentsApiState.status === 'error'
                    "
                    [class.demand-searchable-field__hint--warning]="
                      environmentsApiState.status === 'warning'
                    "
                  >
                    {{ environmentsApiState.message }}
                  </span>
                }
              </div>

              <div class="demand-searchable-field">
                <app-searchable-single-select
                  [options]="equipmentOptions"
                  [selectedValue]="demandForm.get('equipmentUuid')?.value"
                  (selectedValueChange)="handleEquipmentUuidChange($event)"
                  [disabled]="
                    isSubmittingRequest ||
                    loadingEquipments ||
                    !demandForm.get('environmentUuid')?.value
                  "
                  placeholder="{{
                    loadingEquipments
                      ? 'Carregando equipamentos...'
                      : equipmentEmptyMessage
                  }}"
                  searchPlaceholder="Buscar equipamento..."
                  sectionTitle="Equipamentos"
                  [showSectionTitle]="false"
                  [emptyMessage]="equipmentEmptyMessage"
                  selectedSummaryEmpty="Nenhum equipamento selecionado"
                  clearLabel="Desmarcar"
                ></app-searchable-single-select>

                @if (equipmentsApiState.message) {
                  <span
                    class="demand-searchable-field__hint"
                    [class.demand-searchable-field__hint--error]="
                      equipmentsApiState.status === 'error'
                    "
                    [class.demand-searchable-field__hint--warning]="
                      equipmentsApiState.status === 'warning'
                    "
                  >
                    {{ equipmentsApiState.message }}
                  </span>
                }
              </div>
            </div>
          </section>

          <section class="demand-block">
            <div
              class="demand-searchable-field"
              [class.demand-searchable-field--invalid]="
                hasControlError('flowSelection', 'required')
              "
            >
              <app-searchable-single-select
                [options]="managementModelOptions"
                [selectedValue]="demandForm.get('flowSelection')?.value"
                (selectedValueChange)="handleFlowSelectionChange($event)"
                [disabled]="isSubmittingRequest"
                placeholder="Selecione o modelo de gestão"
                searchPlaceholder="Buscar modelo de gestão..."
                sectionTitle="Modelo de gestão"
                [showSectionTitle]="false"
                emptyMessage="Nenhum modelo de gestão encontrado."
                selectedSummaryEmpty="Nenhum modelo de gestão selecionado"
              ></app-searchable-single-select>

              @if (hasControlError('flowSelection', 'required')) {
                <span class="demand-searchable-field__error">
                  Modelo de gestão é obrigatório
                </span>
              }
            </div>
          </section>

          <section class="demand-block demand-block--occurrence">
            <div class="demand-block__header demand-block__header--compact">
              <div>
                <h3>Ocorrencia</h3>
              </div>
              <span class="demand-block__meta">minimo 10 caracteres</span>
            </div>

            <mat-form-field appearance="outline" class="demand-field demand-field--textarea">
              <textarea
                matInput
                formControlName="description"
                rows="5"
                placeholder="Descreva a ocorrencia com o maximo de contexto possivel."
                [disabled]="isSubmittingRequest"
              ></textarea>
              <mat-hint align="end">{{ occurrenceLength }} caracteres</mat-hint>
              @if (hasControlError('description', 'required')) {
                <mat-error>Ocorrencia e obrigatoria</mat-error>
              }
              @if (hasControlError('description', 'minlength')) {
                <mat-error>Deve conter no minimo 10 caracteres</mat-error>
              }
            </mat-form-field>
          </section>
        </div>

        <aside class="demand-request-dialog__media">
          <div class="demand-media-panel__header">
            <h3>Imagens da solicitacao</h3>
          </div>
          <app-image-uploader
            [entity]="{ name: 'demand', uuid: '' }"
            [initialPayload]="data.payloadImages ?? null"
            descriptionPlaceholder="Descricao da imagem"
          ></app-image-uploader>
        </aside>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="demand-request-dialog__actions">
      <button
        type="button"
        mat-stroked-button
        color="warn"
        (click)="closeDialog()"
        [disabled]="isSubmittingRequest"
      >
        Cancelar
      </button>

      <button
        type="submit"
        mat-flat-button
        color="accent"
        class="demand-request-dialog__primary-action"
        [disabled]="isSubmitDisabled"
      >
        @if (isSubmittingRequest) {
          <mat-progress-spinner
            diameter="18"
            mode="indeterminate"
            color="accent"
            strokeWidth="3"
          ></mat-progress-spinner>
          <span>Preparando...</span>
        } @else {
          <span>Solicitar servico</span>
          <i-tabler name="arrow-right" class="demand-request-dialog__action-icon"></i-tabler>
        }
      </button>
    </mat-dialog-actions>
  </form>
</section>
